export default {
  common: {
    formFields: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      secondLastName: 'Segundo apellido',
      email: 'Email',
      phone: 'Teléfono',
      birthYear: 'Año de nacimiento',
      birthDate: 'Fecha de nacimiento',
      postalCode: 'Código postal',
      gender: 'Género',
      title: 'Trato',
      address: 'Dirección',
      company: 'Nombre de empresa',
      password: 'Contraseña',
      passwordConfirmation: 'Confirmación de contraseña',
      remember: '¿Recordar contraseña?',
      communications: 'Quiero recibir actualizaciones y promociones de la plataforma por email.',
      country: 'País',
      emojiReaction: 'Reacción por emoji',
      interests: 'Intereses',
      fields: {
        optional: '(opcional)'
      }
    },
    pay: 'Realizar pedido',
    cv19certificate: 'Descargar Certificado de Móvilidad CV-19',
    gender: {
      female: 'Mujer',
      male: 'Hombre',
      notDefined: 'No definido'
    },
    title: {
      mr: 'Sr.',
      ms: 'Sra.'
    },
    agreement: {
      yes: 'Si',
      no: 'No'
    },
    languages: {
      es_ES: 'Español',
      en_GB: 'English'
    },
    emojiReactions: {
      wow: 'Wow',
      love: 'Enamorado',
      lolCry: 'Llorándo de risa',
      wuaa: 'Wuaa',
      fun: 'Divertido',
      lol: 'Lol',
      kiss: 'Beso',
      cry: 'Triste',
      lovely: 'Encantado',
      angry: 'Enfadado',
      sleep: 'Soñoliento',
      winking: 'Guiño',
      yeah: 'Yeah',
      no: 'No',
      cuteSad: 'Triste y adorable',
      nerd: 'Nerd',
      yes: 'Sí'
    },
    notifications: {
      titles: {
        info: 'Información',
        success: 'Aceptado',
        warning: 'Advertencia',
        error: 'Error'
      },
      messages: {
        requestError: 'Se ha producido un error al procesar tu solicitud. Inténtalo de nuevo más tarde.',
        fullCapacity: 'Muchas gracias por tu interés. En estos momentos el aforo está completo. Si lo deseas, puedes continuar con el registro para formar parte de la lista de espera. En el caso de que alguna plaza se libere, te informaremos.',
        noMoreTickets: 'Muchas gracias por tu interés. En estos momentos el aforo está completo.'
      }
    },
    confirmInvitation: {
      terms: {
        base: 'Acepto los {platform}.',
        platform: 'Términos y Condiciones de la Plataforma'
      },
      privacy: {
        base: 'Acepto la {privacy}.',
        privacy: 'Política de Privacidad'
      },
      sections: {
        basicInfo: {
          title: 'Regístrate para acceder a tus eventos'
        },
        processorAgreement: {
          title: 'Contrato de encargado de tratamiento de datos personales',
          accept: 'Acepto el contrato de encargado de tratamiento'
        },
        success: {
          title: '%{name} ya puedes acceder a tus eventos.',
          action: 'Inicia sesión'
        },
        error: {
          notFound: {
            text: 'Comprueba la URL o contacta con el administrador del evento.',
            verificationCode: 'Tu código de confirmación es: %{code}'
          },
          server: {
            text: '¡Vaya! Hemos tenido un problema al realizar la conexion con el servidor. Intentalo de nuevo más tarde.'
          }
        }
      },
      privacyLegend: {
        terms: {
          info: 'INFORMACIÓN SOBRE PROTECCIÓN DE DATOS DE YUMIWI DATA S.L.,',
          purposes: {
            title: 'Finalidades:',
            text: 'Activar la Cuenta Cliente para la utilización de la Plataforma Yumiwi. '
          },
          legitimation: {
            title: 'Legitimación:',
            text: 'Consentimiento del interesado y el interés legítimo del Responsable del Tratamiento.'
          },
          recipients: {
            title: 'Destinatarios:',
            text: 'La información proporcionada podrá ser compartida con nuestra base de datos de almacenamiento y terceros proveedores de servicios.'
          },
          rights: {
            title: 'Derechos:',
            text: ' Puede retirar su consentimiento en cualquier momento, así como acceder, rectificar, suprimir sus datos y demás derechos en {action}, sin perjuicio de lo establecido en el contrato de prestación de servicios mantenido entre usted y el Responsable del Tratamiento.'
          }
        }
      },
      actions: {
        next: 'Siguiente',
        cancel: 'Cancelar',
        signUp: 'Registrarme'
      }
    },
    dates: {
      seconds: 'hace un segundo | hace {unit} segundos',
      minutes: 'hace un minuto | hace {unit} minutos',
      hours: 'hace una hora | hace {unit} horas',
      days: 'hace un día | hace {unit} dias',
      months: 'hace un mes | hace {unit} meses',
      years: 'hace un año | hace {unit} años'
    }
  },
  event: {
    invitation: {
      unpublish: 'La invitación no está publicada. Publícala para dar acceso a los asistentes.'
    },
    registration: {
      unpublish: 'El registro no está publicado. Publícalo para dar acceso a los asistentes.',
      invalidToken: 'Lo sentimos. Este enlace ya ha sido utilizado o no es válido.'
    },
    timeline: {
      download: 'Descargar',
      unpublish: 'El timeline no está publicado. Publícalo para dar acceso a los asistentes.',
      broadcast: {
        interestsFlag: 'Porque estás interesado en: '
      },
      socials: {
        share: 'Compartir',
        facebook: 'Compartir en Facebook',
        twitter: 'Compartir en Twitter',
        linkedIn: 'Compartir en LinkedIn',
        whatsapp: 'Compartir en Whatsapp',
        email: 'Compartir por Email'
      },
      expressions: {
        love: 'Me encanta',
        lolCry: 'Me divierte',
        wow: 'Me asombra',
        cry: 'Me entristece',
        angry: 'Me enfada'
      },
      eventFeedback: {
        buttonActions: {
          send: 'Enviar',
          remove: 'Eliminar'
        }
      },
      scratchAndWin: {
        buttonActions: {
          check: 'Comprobar',
          reset: 'Probar otra vez'
        },
        reaction: {
          won: {
            title: '¡Has ganado!',
            reward: 'Recoge tu "%{reward}" mostrando el código %{code}.'
          },
          lost: {
            title: '¡Qué pena!',
            noReward: 'El código %{code} no tiene premio.',
            tryAgain: 'Siempre puedes volver a intentarlo.'
          }
        },
        errors: {
          invalid: 'El código %{code} es inválido.',
          alreadyUsed: 'El código %{code} ya ha sido utilizado.'
        }
      },
      raffle: {
        statuses: {
          thankYou: '¡Gracias por participar!',
          noGift: 'No quedan regalos.'
        },
        reaction: {
          won: '¡Has ganado!',
          lost: '¡Qué pena!'
        }
      },
      question: {
        buttonActions: {
          answer: 'Contestar'
        },
        messages: {
          thanksToResponse: 'Muchas gracias por contestar',
          answer: 'Su respuesta: %{answer}.',
          timeOver: 'Lo sentimos mucho, pero el tiempo para contestar se ha acabado.'
        }
      },
      buttonActions: {
        save: 'Guardar',
        signIn: 'Registrarse'
      },
      labels: {
        images: 'Fotos',
        videos: 'Videos',
        gifts: 'Regalos',
        files: 'Ficheros',
        downloads: 'Descargas',
        gifs: 'Memes',
        announces: 'Anuncios'
      },
      zoomMeeting: {
        title: 'Tu reunión de Zoom empieza en',
        button: 'Unirse a la reunión de Zoom',
        days: 'días',
        hours: 'horas',
        minutes: 'minutos',
        seconds: 'segundos'
      }
    }
  }
}
